// extracted by css-extract-rspack-plugin
export default {"FilterChip":"FilterChip_FilterChip__ZtJNx","noIcon":"FilterChip_noIcon__k0Jxm","selected":"FilterChip_selected__m74Jq","icon":"FilterChip_icon__0nYni"};